module.exports = __webpack_public_path__ + "files/91faa912b8c5a92f4613b4845e9aabb9.png";